var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineArrowRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.266 16.4a.503.503 0 0 1 0-.707L16.96 12l-3.693-3.693a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l4.046 4.047a.503.503 0 0 1 0 .706L13.973 16.4c-.1.1-.227.147-.354.147a.494.494 0 0 1-.353-.147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.333 12.5a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h11.22c.274 0 .5.227.5.5s-.226.5-.5.5H6.333z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineArrowRight2);
export default __webpack_public_path__ + "static/media/vuesax-outline-arrow-right_2.bfb317863b3a09e1c07e436da57cef22.svg";
export { ForwardRef as ReactComponent };